import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import React from 'react';
import { AlgoliaHitTransformer } from '../../../Algolia/transformers/AlgoliaHitTransformer';
import { useCustomerContext } from '../../../context/CustomerContextProvider';
import { useEventsContext } from '../../../context/Events';
import { useProductActionsContext } from '../../../context/ProductActionsProvider';
import { ProductCard } from '../../../ProductCard';
import { useProductCompare } from '../../../ProductCompare';
import { TrackingDescriptorType } from '../../../Tracking/types';

export const ProductComponent = ({
  hit,
  position,
  trackingDescriptor: trackingDescriptorProp,
  trackingListName: trackingListNameProp,
  trackingListPrefix,
}: {
  hit: AlgoliaProductHit;
  position?: number;
  trackingDescriptor?: TrackingDescriptorType;
  trackingListName?: string;
  trackingListPrefix?: string;
}) => {
  const { onAddToCart, productCartPropsOverrides = {} } = useProductActionsContext();
  const { isAddedToCompare, compareHandleClick, shouldShowCompare } = useProductCompare(false);
  const { isLoggedIn, handleUpdateWishlist, getIsInWishlist } = useCustomerContext();
  let trackingListName =
    trackingListNameProp || trackingDescriptorProp?.ecommerceExtraProps?.list || 'STACK - Carousel';
  trackingListName &&= trackingListPrefix ?? '';
  const trackingDescriptor: TrackingDescriptorType = {
    page: '',
    group: trackingListName,
    category: trackingListName,
    ...(trackingDescriptorProp ?? {}),
    ecommerceExtraProps: {
      ...(trackingDescriptorProp?.ecommerceExtraProps ?? {}),
      position,
      list: trackingListName,
    },
  };
  const { postEvent } = useEventsContext();

  return (
    <ProductCard
      {...AlgoliaHitTransformer.toProductCardProps(hit, { trackingDescriptor })}
      {...productCartPropsOverrides}
      variant="tablet"
      getIsCompared={isAddedToCompare}
      onCompare={compareHandleClick}
      getShouldShowCompare={shouldShowCompare}
      isLoggedIn={isLoggedIn}
      onUpdateWishlist={handleUpdateWishlist}
      getIsInWishlist={getIsInWishlist}
      onClick={() => {
        postEvent({
          name: 'component.productcard.click',
          data: { sku: hit.sku, queryId: hit.__queryID, position: position },
        });
      }}
      onAddToCart={
        onAddToCart
          ? (e, _sku, variantId, eventData) => onAddToCart(e, hit, variantId, eventData?.trackingDescriptor)
          : undefined
      }
      tooltipVariant="small"
    />
  );
};
